import React, { useState, useEffect } from "react";
import { orderBy } from "@progress/kendo-data-query";
import styles from "../Settings.module.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import { Button } from "@progress/kendo-react-buttons";
import ContactLinkTypeModal from "./ContactLinkTypeModal";
import { getContactLinks } from "api/index";

const initialSort = [
  {
    field: "categoryName",
    dir: "asc",
  },
];

const ContactLinkDataGrid = () => {
  const [data, setData] = useState([]);
  const [sort, setSort] = useState(initialSort);
  const [modalData, setModalData] = useState(null);
  const [modal, setModal] = useState(false);

  const getItems = async () => {
    try {
      const { data } = await getContactLinks();
      setData(data.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getItems();
  }, []);

  const enterEdit = (dataItem) => {
    return handleModalOpen(dataItem);
  };

  const CommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const BlankHeader = () => <span />;

  const handleModalOpen = (actionData = null) => {
    setModalData(actionData);
    setModal(true);
  };

  const handleModalClose = (shouldRefresh = false) => {
    if (shouldRefresh) {
      getItems();
    }
    setModal(false);
  };

  return (
    <>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn ms-3 col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              handleModalOpen(null);
            }}
          >
            Add Contact<br></br>
            Category
          </Button>
        </div>
        <div className={`row mx-auto mt-3 col-12 col-xl-9`}>
          <div className="settings-grid">
            <Grid
              resizable={true}
              reorderable={true}
              data={orderBy(data, sort)}
              sortable={true}
              sort={sort}
              onSortChange={(e) => {
                setSort(e.sort);
              }}
              rowHeight={40}
              scrollable="scrollable"
              dataItemKey={"contactCategoryId"}
            >
              <Column
                field="categoryName"
                title=" "
                cell={SignatureCell}
                width="80"
                sortable={false}
                headerCell={BlankHeader}
              />
              <Column field="categoryName" title="Name" width={"120"} />
              <Column field="categoryDetails" title="Details" width={"180"} />
              <Column field="labelForRef1" title="Reference 1" width={"120"} />
              <Column field="labelForRef2" title="Reference 2" width={"120"} />
              <Column field="labelForRef3" title="Reference 3" width={"120"} />
              <Column
                field="active"
                cell={ActiveCell}
                title="Active"
                editor="boolean"
                width="80"
              />
              <Column cell={CommandCell} width="80" />
            </Grid>
          </div>
        </div>
      </>
      {modal && (
        <ContactLinkTypeModal onClose={handleModalClose} data={modalData} />
      )}
    </>
  );
};
export default ContactLinkDataGrid;
